import React, { useEffect } from 'react'

export default function BitrixHandler() {
    useEffect(() => {
        const query = window.location.search || ''
        window.location.href = `https://v-office.ats.am/rest/bitrix24/index${query}`
    }, [])
    return null
}
